/* AZMARA - Warenkorb-Fenster v3 (nur Test-Kopie)
   1) Lieferdatum "bis Dienstag (20.10.) bei dir" (gleiche Regeln wie auf der Produktseite)
   2) Gratisversand-Karte in Gold (baut den bestehenden Balken um)
   3) Papierkorb mit "Rueckgaengig" und Hinweis "hinzugefuegt"
   4) Scroll-Hinweis (Verlauf unten) und Schnellzahl-Knoepfe nach jeder Warenkorb-Aenderung neu laden
   5) Rabatt (Google-Rabatt ODER Streichpreis am Produkt): alter Preis durchgestrichen, daneben der aktuelle Preis in Gruen (je Produkt UND bei "Gesamt")
      + Kennzeichnung "Google-Rabatt" je Produkt im Fenster
      + Herkunft (Suche / Plus-Vorschlag / Sofort bezahlen) wird als Zusatzinfo am Warenkorb gespeichert
      + auf der Warenkorb-Seite: Codename "Google_Discount_XXXX" wird zu "Google-Rabatt", Rabattpreis gruen */
(function () {
  'use strict';

  /* ===== 1) Lieferdatum ===== */
  var K = { cutoffStunde: 14, lieferTageMax: 3, schliesstage: ['24-12', '31-12'] };

  function osterSonntag(j) {
    var a = j % 19, b = Math.floor(j / 100), c = j % 100;
    var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var monat = Math.floor((h + l - 7 * m + 114) / 31);
    var tag = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(j, monat - 1, tag);
  }
  function schluessel(d) { return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
  var speicher = {};
  function feiertage(j) {
    if (speicher[j]) return speicher[j];
    var liste = {};
    var fest = [[1,1],[1,6],[5,1],[8,15],[10,3],[10,26],[11,1],[12,8],[12,25],[12,26]];
    var x, y, z;
    for (x = 0; x < fest.length; x++) liste[j + '-' + fest[x][0] + '-' + fest[x][1]] = true;
    for (y = 0; y < K.schliesstage.length; y++) {
      var t = K.schliesstage[y].split('-');
      liste[j + '-' + parseInt(t[1], 10) + '-' + parseInt(t[0], 10)] = true;
    }
    var o = osterSonntag(j), versatz = [-2, 1, 39, 50, 60];
    for (z = 0; z < versatz.length; z++) {
      var dd = new Date(o.getFullYear(), o.getMonth(), o.getDate() + versatz[z]);
      liste[schluessel(dd)] = true;
    }
    speicher[j] = liste;
    return liste;
  }
  function istWerktag(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    return !feiertage(d.getFullYear())[schluessel(d)];
  }
  function naechsterWerktag(d) {
    var x = new Date(d.getTime());
    do { x.setDate(x.getDate() + 1); } while (!istWerktag(x));
    return x;
  }
  function zustellung() {
    var jetzt = new Date();
    var versand = new Date(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate());
    if (!istWerktag(versand) || jetzt.getHours() >= K.cutoffStunde) versand = naechsterWerktag(versand);
    var ziel = versand;
    for (var i = 0; i < K.lieferTageMax; i++) ziel = naechsterWerktag(ziel);
    return ziel;
  }
  function formatiere(d) {
    var wt = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'][d.getDay()];
    var t = ('0' + d.getDate()).slice(-2), m = ('0' + (d.getMonth() + 1)).slice(-2);
    return wt + ' (' + t + '.' + m + '.)';
  }
  function setEta() {
    var els = document.querySelectorAll('.az-eta__text');
    var txt = 'bis ' + formatiere(zustellung()) + ' bei dir';
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== txt) els[i].textContent = txt;
      if (els[i].parentNode) els[i].parentNode.hidden = false;
    }
  }

  /* ===== 2) Gratisversand-Karte in Gold ===== */
  var PKG = '<svg aria-hidden="true" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#a8863f" stroke-width="1.8"><path d="M12 2l9 5v10l-9 5-9-5V7l9-5zM3 7l9 5 9-5M12 12v10"/></svg>';
  var TICK = '<svg aria-hidden="true" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5 9-10"/></svg>';

  var lastPct = null;
  function goldify() {
    var tb = document.querySelector('.az-topbar');
    var root = document.querySelector('.mini-cart-content');
    var titles = document.querySelectorAll('.azxs--drawer .azxs__title');
    for (var j = 0; j < titles.length; j++) {
      var tx = titles[j].textContent;
      if (tx === 'Jetzt Gratisversand sichern' || tx === 'Jetzt ergänzen' || tx === 'Passende Düfte für dich') titles[j].textContent = 'Passende Ergänzungen';
      else if (tx === 'Dazu passt auch') titles[j].textContent = 'Entdecke noch mehr';
    }
    if (!tb || !root) return;
    var el = document.querySelector('.azxs--drawer .azxs__ship');
    if (!el) {
      if (!footerVisible() || document.querySelector('.js-mini-cart-content .mini-cart-empty, .mini-cart-content .mini-cart-empty')) { tb.hidden = true; tb.removeAttribute('data-az-gold'); root.classList.remove('az-bar-on'); lastPct = null; }
      return;
    }
    var done = el.classList.contains('azxs__ship--done');
    var bar = el.querySelector('.progress-bar');
    var span = el.querySelector('.free-shipping-content span');
    var pct = bar ? parseFloat(bar.getAttribute('aria-valuenow')) : NaN;
    var amount = span ? (span.textContent.match(/€\s?[\d.,]+/) || [''])[0] : '';
    if (!done && (isNaN(pct) || !amount)) return;
    var key = done ? 'done' : (amount + '|' + pct);
    if (tb.getAttribute('data-az-gold') === key) return;
    var html;
    if (done) {
      html = '<div class="az-gold__title"><strong>Gratisversand</strong> erreicht</div>' +
        '<div class="az-gold__bar"><div class="az-gold__track"></div><div class="az-gold__fill" style="width:100%"></div>' +
        '<div class="az-gold__end az-gold__end--done">' + TICK + '</div></div>' +
        '<div class="az-gold__label"><span>&nbsp;</span></div>';
    } else {
      html = '<div class="az-gold__title">Noch <strong>' + amount.replace(/\s/g, '') + '</strong> bis Gratisversand</div>' +
        '<div class="az-gold__bar"><div class="az-gold__track"></div><div class="az-gold__fill" style="width:' + pct + '%"></div>' +
        '<div class="az-gold__knob" style="left:' + pct + '%"></div>' +
        '<div class="az-gold__end">' + PKG + '</div></div>' +
        '<div class="az-gold__label"><span>ab €75</span></div>';
    }
    var target = done ? 100 : pct;
    var from = (lastPct === null || isNaN(lastPct)) ? target : lastPct;
    tb.innerHTML = html;
    tb.hidden = false;
    tb.setAttribute('data-az-gold', key);
    root.classList.add('az-bar-on');
    var fillEl = tb.querySelector('.az-gold__fill');
    var knobEl = tb.querySelector('.az-gold__knob');
    if (fillEl && from !== target) {
      fillEl.style.transition = 'none';
      fillEl.style.width = from + '%';
      if (knobEl) { knobEl.style.transition = 'none'; knobEl.style.left = from + '%'; }
      void fillEl.offsetWidth;
      fillEl.style.transition = '';
      fillEl.style.width = target + '%';
      if (knobEl) { knobEl.style.transition = ''; knobEl.style.left = target + '%'; }
    }
    lastPct = target;
  }

  /* ===== 3) Papierkorb, Rueckgaengig, Hinweis ===== */
  var toastEl = null, toastTimer = null, undoData = null, lastAddName = '';

  function footerOffset() {
    var f = document.querySelector('.mini-cart-footer');
    var visible = f && f.offsetParent !== null;
    return visible ? f.offsetHeight + 10 : 24;
  }
  function hideToast() {
    if (!toastEl) return;
    toastEl.hidden = true;
    clearTimeout(toastTimer);
  }
  function showToast(text, kind, undo, ms) {
    toastEl = toastEl || document.querySelector('.az-toast');
    if (!toastEl) return;
    var msg = toastEl.querySelector('.az-toast__msg');
    var btn = toastEl.querySelector('.az-toast__undo');
    msg.textContent = text;
    btn.hidden = !undo;
    toastEl.className = 'az-toast az-toast--' + kind;
    toastEl.style.bottom = footerOffset() + 'px';
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; undoData = null; }, ms);
  }
  function reloadDrawer() {
    var sc = document.querySelector('.az-cart-scroll');
    var list = document.querySelector('.az-cart-scroll .js-mini-cart-content');
    var top = sc ? sc.scrollTop : 0;
    if (list) list.style.minHeight = list.offsetHeight + 'px';
    try {
      if (window.theme && theme.miniCart) { theme.miniCart.updateElements(); theme.miniCart.generateCart(); }
    } catch (e) { /* ignorieren */ }
    setTimeout(function () { if (sc) sc.scrollTop = top; }, 60);
    setTimeout(function () { if (sc) sc.scrollTop = top; if (list) list.style.minHeight = ''; }, 700);
    refreshExpressSoon();
  }

  function onRemoveClick(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.js-remove-mini-cart') : null;
    if (!b || !b.closest('.js-mini-cart')) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();
    var id = b.getAttribute('data-id');
    var row = b.closest('.mini-cart-item');
    if (row) {
      var rh = row.offsetHeight;
      row.style.overflow = 'hidden';
      row.style.height = rh + 'px';
      void row.offsetHeight;
      row.style.transition = 'height .25s ease, opacity .2s ease, margin .25s ease, padding .25s ease';
      row.style.opacity = '0';
      row.style.height = '0px';
      row.style.marginTop = '0px';
      row.style.marginBottom = '0px';
      row.style.paddingTop = '0px';
      row.style.paddingBottom = '0px';
    }
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = null;
        for (var i = 0; i < cart.items.length; i++) { if (String(cart.items[i].id) === String(id)) { item = cart.items[i]; break; } }
        if (!item) { reloadDrawer(); return null; }
        undoData = { id: item.id, quantity: item.quantity, properties: item.properties || {}, title: item.product_title || item.title };
        try { if (window.theme && theme.GiftWrap && theme.GiftWrap.checkGift) theme.GiftWrap.checkGift(item.id); } catch (e) { /* ignorieren */ }
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(item.id), quantity: 0 })
        }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          reloadDrawer();
          showToast(undoData.title + ' entfernt', 'undo', true, 7000);
        });
      })
      .catch(function () { undoData = null; reloadDrawer(); });
  }

  function onUndoClick(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.az-toast__undo') : null;
    if (!b || !undoData) return;
    var d = undoData;
    undoData = null;
    hideToast();
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: d.id, quantity: d.quantity, properties: d.properties })
    }).then(function () { reloadDrawer(); }).catch(function () { reloadDrawer(); });
  }

  function onAddClickCapture(ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('.azxs__add') : null;
    if (!b || !b.closest('.js-mini-cart')) return;
    var label = b.getAttribute('aria-label') || '';
    lastAddName = label.replace(/ in den Warenkorb legen$/, '');
    undoData = null;
  }

  function hookAjax() {
    if (!window.jQuery || window.__azV3Ajax) return;
    window.__azV3Ajax = true;
    jQuery(document).ajaxComplete(function (e, xhr, opts) {
      var u = String((opts && opts.url) || '');
      if (/\/cart\/add/.test(u) && xhr.status >= 200 && xhr.status < 300 && lastAddName) {
        showToast(lastAddName + ' hinzugefügt', 'ok', false, 3500);
        lastAddName = '';
      }
      if (/\/cart\/(add|change|update|clear)/.test(u)) { refreshExpressSoon(); setTimeout(syncPrices, 350); }
    });
  }

  /* ===== 4) Scroll-Hinweis ===== */
  function updateFade() {
    var sc = document.querySelector('.az-cart-scroll');
    var fade = document.querySelector('.az-cart-fade');
    if (!sc || !fade) return;
    var more = sc.scrollHeight - sc.scrollTop - sc.clientHeight > 8;
    fade.classList.toggle('is-end', !more);
  }

  /* ===== 5) Rabatt: alter Preis durchgestrichen, daneben der aktuelle Preis ===== */
  /* Zwei Faelle:
     - "code": ein Rabattcode (z.B. Google-Rabatt) senkt den Preis -> durchgestrichen wird der normale Verkaufspreis
     - "cmp" : das Produkt hat einen Streichpreis (compare_at_price) -> durchgestrichen wird der Streichpreis
     Hat ein Produkt beides, gilt "code" (so wie auf der Produktseite). */
  /* Aufbau der Zeile im Theme: <span>€39,99</span> x 1  (Preis im span, " x 1" als Text direkt danach) */
  var lastCartData = null, priceFetchAt = 0, priceFetching = false, priceTimer = null;
  function euro(c) {
    var p = (c / 100).toFixed(2).split('.');
    return '€' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
  }
  var QTY_RE = /^\s*[x×]\s*(\d+)\s*$/;
  function findPriceEl(row) {
    var marked = row.querySelector('[data-az-price]');
    if (marked) return marked;
    var spans = row.querySelectorAll('.mini-cart-meta > span'), i, n;
    for (i = 0; i < spans.length; i++) {
      n = spans[i].nextSibling;
      if (n && n.nodeType === 3 && QTY_RE.test(n.nodeValue)) return spans[i];
    }
    return null;
  }

  /* Streichpreise (compare_at_price) je Variante: aus /products/HANDLE.js, 15 Minuten in sessionStorage gemerkt */
  var CMP = {}, cmpDone = {}, CMP_TTL = 15 * 60 * 1000;
  function cmpRead(h) {
    try {
      var raw = sessionStorage.getItem('az-cmp:' + h);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.m || Date.now() - o.t > CMP_TTL) return null;
      return o.m;
    } catch (e) { return null; }
  }
  function cmpWrite(h, m) { try { sessionStorage.setItem('az-cmp:' + h, JSON.stringify({ t: Date.now(), m: m })); } catch (e) { /* ignorieren */ } }
  function cmpAdd(m) { for (var k in m) { if (Object.prototype.hasOwnProperty.call(m, k)) CMP[k] = m[k]; } }
  function loadCompare(cart, done) {
    if (!cart || !cart.items) return;
    var need = [], i, h;
    for (i = 0; i < cart.items.length; i++) {
      h = cart.items[i].handle;
      if (h && !cmpDone[h] && need.indexOf(h) < 0) need.push(h);
    }
    if (!need.length) return;
    var left = need.length;
    need.forEach(function (hh) {
      cmpDone[hh] = true;
      function fin() { left--; if (left === 0) done(); }
      var c = cmpRead(hh);
      if (c) { cmpAdd(c); fin(); return; }
      fetch('/products/' + encodeURIComponent(hh) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (p) {
          var m = {};
          (p.variants || []).forEach(function (v) { m[v.id] = v.compare_at_price || 0; });
          cmpWrite(hh, m);
          cmpAdd(m);
        })
        .catch(function () { /* ohne Streichpreis weiter */ })
        .then(fin);
    });
  }
  /* kind: code | cmp | none; unit = durchgestrichener Stueckpreis, line = durchgestrichene Zeilensumme */
  function refInfo(it) {
    var q = it.quantity;
    if (it.final_line_price < it.original_line_price) return { kind: 'code', unit: it.original_price, line: it.original_line_price };
    var c = CMP[it.id];
    if (c && c > it.original_price) return { kind: 'cmp', unit: c, line: c * q };
    return { kind: 'none', unit: it.original_price, line: it.original_line_price };
  }
  function refTotalOf(cart) {
    var s = 0, i;
    for (i = 0; i < cart.items.length; i++) s += refInfo(cart.items[i]).line;
    return s;
  }
  /* kommt der Preisnachlass dieser Zeile von einem Google-Rabattcode? */
  function isGoogleItem(it) {
    var d = it.discounts || [], j;
    for (j = 0; j < d.length; j++) { if (/^\s*Google_Discount_/i.test(d[j].title || '')) return true; }
    return false;
  }
  /* kleine gruene Zeile "Google-Rabatt" unter dem Preis (Warenkorb-Fenster) */
  function setGoogleLabel(el, show) {
    var meta = el.parentNode;
    if (!meta) return;
    var lab = meta.querySelector('[data-az-gl]');
    if (show && !lab) {
      lab = document.createElement('small');
      lab.setAttribute('data-az-gl', '1');
      lab.style.cssText = 'display:block;color:#1d7a3a;font-size:11px;font-weight:600;line-height:1.3;margin-top:2px';
      lab.textContent = 'Google-Rabatt';
      meta.insertBefore(lab, el.nextElementSibling);
    } else if (!show && lab) {
      lab.parentNode.removeChild(lab);
    }
  }

  /* "Gesamt": normaler Gesamtpreis durchgestrichen, daneben der aktuelle (Warenkorb-Fenster und Warenkorb-Seite) + "Du sparst" */
  function applyTotals(cart) {
    if (!cart || !cart.items || typeof cart.total_price !== 'number') return;
    var ref = refTotalOf(cart), total = cart.total_price;
    var els = document.querySelectorAll('.js-mini-cart .js-cart-total, #CartSubtotal'), i, el, marked, key;
    var disc = ref > total;
    for (i = 0; i < els.length; i++) {
      el = els[i];
      marked = el.querySelector('s[data-az-t]');
      if (disc) {
        key = ref + '|' + total;
        if (marked && el.getAttribute('data-az-total') === key) continue;
        /* Theme hat gerade einen neuen Wert geschrieben, die Daten sind noch alt -> warten */
        if (!marked && el.textContent.replace(/\s/g, '') !== euro(total)) continue;
        el.innerHTML = '<s data-az-t="1" style="color:#8a8a8a;text-decoration:line-through;font-weight:400;margin-right:6px">' + euro(ref) + '</s>' +
          '<b style="color:#1d7a3a;font-weight:inherit">' + euro(total) + '</b>';
        el.setAttribute('data-az-total', key);
      } else if (marked) {
        el.textContent = euro(total);
        el.removeAttribute('data-az-total');
      }
    }
    /* "Du sparst" (Fenster) / "Sie sparen" (Warenkorb-Seite): schliesst Streichpreis-Ersparnis mit ein */
    var sv = document.querySelectorAll('#MiniCartSavings, [id="cartDiscountTotal txt-body-70"]'), txt, s2;
    for (i = 0; i < sv.length; i++) {
      s2 = sv[i];
      if (disc) {
        if (!s2.hasAttribute('data-az-sv') && el === undefined) continue;
        txt = (s2.id === 'MiniCartSavings' ? 'Du sparst ' : 'Sie sparen ') + euro(ref - total);
        if (s2.textContent.replace(/\s+/g, ' ').trim() !== txt) s2.textContent = txt;
        if (s2.style.display === 'none') s2.style.display = 'block';
        s2.setAttribute('data-az-sv', '1');
      } else if (s2.hasAttribute('data-az-sv')) {
        s2.removeAttribute('data-az-sv');
        s2.textContent = '';
        s2.style.display = 'none';
      }
    }
  }
  function applyPrices(cart) {
    if (!cart || !cart.items) return;
    applyTotals(cart);
    applyCartPage(cart);
    var rows = document.querySelectorAll('.js-mini-cart .mini-cart-item');
    for (var r = 0; r < rows.length; r++) {
      var row = rows[r];
      var rb = row.querySelector('.js-remove-mini-cart');
      var id = rb ? String(rb.getAttribute('data-id')) : '';
      var it = null, k;
      for (k = 0; k < cart.items.length; k++) { if (String(cart.items[k].id) === id) { it = cart.items[k]; break; } }
      if (!it && cart.items.length === rows.length) it = cart.items[r];
      if (!it) continue;
      var el = findPriceEl(row);
      if (!el) continue;
      var qm = el.nextSibling && el.nextSibling.nodeType === 3 ? el.nextSibling.nodeValue.match(QTY_RE) : null;
      if (qm && Number(qm[1]) !== it.quantity) continue;
      var info = refInfo(it);
      setGoogleLabel(el, info.kind === 'code' && isGoogleItem(it));
      var key = info.kind === 'code' ? (it.original_price + '|' + it.final_line_price + '|' + it.quantity)
        : info.kind === 'cmp' ? ('c|' + info.unit + '|' + it.final_line_price + '|' + it.quantity) : 'plain';
      if (info.kind !== 'none') {
        if (el.getAttribute('data-az-price') === key) continue;
        el.innerHTML = '<s style="color:#8a8a8a;text-decoration:line-through">' + euro(info.unit) + '</s> ' +
          '<b style="color:#1d7a3a;font-weight:600">' + euro(Math.round(it.final_line_price / it.quantity)) + '</b>';
        el.setAttribute('data-az-price', key);
      } else if (el.hasAttribute('data-az-price')) {
        el.removeAttribute('data-az-price');
        el.textContent = euro(it.original_price);
      }
    }
  }
  function syncPrices() {
    if (lastCartData) applyPrices(lastCartData);
    var now = Date.now();
    if (priceFetching) return;
    if (now - priceFetchAt < 300) { clearTimeout(priceTimer); priceTimer = setTimeout(syncPrices, 350); return; }
    priceFetching = true;
    priceFetchAt = now;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (c) {
        lastCartData = c;
        applyPrices(c);
        loadCompare(c, function () { if (lastCartData) applyPrices(lastCartData); });
        srcReconcile(c);
      })
      .catch(function () { /* Preis bleibt wie vom Theme */ })
      .then(function () { priceFetching = false; });
  }

  /* Warenkorb-Seite: Produkte mit Streichpreis bekommen den durchgestrichenen alten Preis (die Seite zeigt sonst nur bei Rabattcode einen) */
  function applyCartPage(cart) {
    var tb = document.getElementById('CartProducts');
    if (!tb || !cart || !cart.items) return;
    var rows = tb.querySelectorAll('tr.cart__row');
    if (rows.length !== cart.items.length) return;
    var i, j, it, info, qin, spans, sp, br, cur, mine, key, sm;
    for (i = 0; i < rows.length; i++) {
      it = cart.items[i];
      info = refInfo(it);
      qin = rows[i].querySelector('input[name="updates[]"]');
      if (qin && Number(qin.value) !== it.quantity) continue;
      spans = rows[i].querySelectorAll('span.cart__item-total');
      for (j = 0; j < spans.length; j++) {
        sp = spans[j];
        br = sp.previousElementSibling;
        cur = br && br.tagName === 'BR' ? br.previousElementSibling : null;
        mine = cur && cur.hasAttribute('data-az-cmp') ? cur : null;
        if (info.kind === 'cmp') {
          if (sp.textContent.replace(/\s/g, '') !== euro(it.final_line_price)) continue;
          key = info.line + '|' + it.final_line_price;
          if (mine) {
            if (mine.getAttribute('data-az-cmp') !== key) { mine.querySelector('s').textContent = euro(info.line); mine.setAttribute('data-az-cmp', key); }
            continue;
          }
          if (cur && cur.classList.contains('cart-item__original-price')) continue;
          sm = document.createElement('small');
          sm.className = 'cart-item__original-price cart__item-total';
          sm.setAttribute('data-az-cmp', key);
          sm.innerHTML = '<s>' + euro(info.line) + '</s>';
          sp.parentNode.insertBefore(sm, sp);
          sp.parentNode.insertBefore(document.createElement('br'), sp);
        } else if (mine) {
          br.parentNode.removeChild(br);
          mine.parentNode.removeChild(mine);
          sp.style.removeProperty('color');
          sp.style.removeProperty('font-weight');
          sp.removeAttribute('data-az-green');
        }
      }
    }
  }

  /* Warenkorb-Seite: statt "Google_Discount_8BNB940HF" soll "Google-Rabatt" stehen; rabattierter Preis gruen, Originalpreis grau
     (setProperty mit important, weil das Theme die Textfarbe mit !important setzt) */
  function cleanCodeNames() {
    var els = document.querySelectorAll('.cart-item__discount'), i, n, o, s;
    for (i = 0; i < els.length; i++) {
      if (/^\s*Google_Discount_/i.test(els[i].textContent)) els[i].textContent = 'Google-Rabatt';
    }
    o = document.querySelectorAll('#CartProducts .cart-item__original-price');
    for (i = 0; i < o.length; i++) {
      s = o[i].querySelector('s');
      if (s) s.style.setProperty('color', '#8a8a8a', 'important');
      n = o[i].nextElementSibling;
      while (n && !(n.tagName === 'SPAN' && n.classList.contains('cart__item-total'))) n = n.nextElementSibling;
      if (n && n.getAttribute('data-az-green') !== '1') {
        n.style.setProperty('color', '#1d7a3a', 'important');
        n.style.setProperty('font-weight', '600', 'important');
        n.setAttribute('data-az-green', '1');
      }
    }
  }
  function watchCartPage() {
    cleanCodeNames();
    var tb = document.getElementById('CartProducts');
    if (tb && window.MutationObserver) new MutationObserver(function () { if (lastCartData) applyCartPage(lastCartData); cleanCodeNames(); }).observe(tb, { childList: true, subtree: true, characterData: true });
    var st = document.getElementById('CartSubtotal');
    if (st && window.MutationObserver) new MutationObserver(function () { if (lastCartData) applyTotals(lastCartData); }).observe(st, { childList: true, characterData: true, subtree: true });
  }


  /* ===== 6) Herkunft der Kaeufe: Suche / Plus-Vorschlag / Sofort bezahlen =====
     Merkt sich in diesem Besuch (sessionStorage), woher ein Artikel kam, und schreibt es als Zusatzinfo an den Warenkorb.
     Die Infos erscheinen in der Bestellung unter "Zusaetzliche Details": Quelle Suche, Quelle Plus-Vorschlag, Sofort bezahlen geoeffnet. */
  var SRC_KEY = 'az-src', srcBusy = false;
  function srcRead() {
    try {
      var o = JSON.parse(sessionStorage.getItem(SRC_KEY) || '{}');
      return { s: o.s || {}, p: o.p || {}, e: o.e || 0 };
    } catch (e) { return { s: {}, p: {}, e: 0 }; }
  }
  function srcWrite(o) { try { sessionStorage.setItem(SRC_KEY, JSON.stringify(o)); } catch (e) { /* ignorieren */ } }
  function handleOf(url) { var m = String(url || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
  function paramOf(url, name) {
    var m = String(url || '').match(new RegExp('[?&]' + name + '=([^&#]*)'));
    if (!m) return '';
    try { return decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (e) { return m[1]; }
  }
  function srcSearch(handle, term) {
    term = String(term || '').replace(/\s+/g, ' ').trim().slice(0, 60);
    if (!handle || !term) return;
    var o = srcRead(); o.s[handle] = term; srcWrite(o);
  }
  function srcPlus(variantId, where) {
    if (!variantId) return;
    var o = srcRead(); o.p[String(variantId)] = where || 'Seite'; srcWrite(o);
  }
  function srcExpress() { var o = srcRead(); if (!o.e) { o.e = 1; srcWrite(o); } }
  /* Produktseite wurde aus der Suche geoeffnet (Link enthaelt _psq=Suchbegriff) */
  function srcPageLoad() {
    var h = handleOf(location.pathname), t = paramOf(location.search, '_psq');
    if (h && t) srcSearch(h, t);
  }
  /* Klick auf ein Produkt in den Suchvorschlaegen oder auf der Suchseite */
  function onSrcClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var plus = t.closest('.azxs__add');
    if (plus) { srcPlus(plus.getAttribute('data-id'), plus.closest('.js-mini-cart') ? 'Warenkorb-Fenster' : 'Seite'); syncPrices(); return; }
    var a = t.closest('a[href*="/products/"]');
    if (!a) return;
    var h = handleOf(a.getAttribute('href')), term = paramOf(a.getAttribute('href'), '_psq');
    if (!term && a.closest('#predictive-search-results, .predictive-search')) {
      var inp = document.querySelector('#Search-In-Modal'); term = inp ? inp.value : '';
    }
    if (!term && /^\/search/.test(location.pathname)) term = paramOf(location.search, 'q');
    if (h && term) srcSearch(h, term);
  }
  /* Zusatzinfos am Warenkorb nur schreiben, wenn sie sich geaendert haben */
  function srcReconcile(cart) {
    if (!cart || !cart.items || srcBusy) return;
    var o = srcRead(), s = [], p = [], i, it, h;
    for (i = 0; i < cart.items.length; i++) {
      it = cart.items[i]; h = it.handle;
      if (h && o.s[h]) s.push(o.s[h] + ' → ' + (it.product_title || h));
      if (o.p[String(it.id)]) p.push((it.product_title || h) + ' (' + o.p[String(it.id)] + ')');
    }
    var want = {
      'Quelle Suche': s.join('; ').slice(0, 250),
      'Quelle Plus-Vorschlag': p.join('; ').slice(0, 250),
      'Sofort bezahlen geöffnet': (cart.items.length && o.e) ? 'ja' : ''
    };
    var have = (cart.attributes && !Array.isArray(cart.attributes)) ? cart.attributes : {}, diff = {}, any = false, k;
    for (k in want) {
      if (Object.prototype.hasOwnProperty.call(want, k) && String(have[k] || '') !== want[k]) { diff[k] = want[k]; any = true; }
    }
    if (!any) return;
    srcBusy = true;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: diff })
    }).then(function (r) { if (r.ok) return r.json(); throw new Error('HTTP ' + r.status); })
      .then(function (c) { if (lastCartData && c && c.attributes) lastCartData.attributes = c.attributes; })
      .catch(function () { /* beim naechsten Mal erneut */ })
      .then(function () { srcBusy = false; });
  }

  /* ===== Schnellzahl-Knoepfe nach Aenderung neu laden (Shopify-Vorgabe fuer Warenkorb-Fenster) ===== */
  var exprTimer = null, exprSeq = 0;
  function refreshExpressSoon() {
    clearTimeout(exprTimer);
    exprTimer = setTimeout(refreshExpress, 500);
  }
  function refreshExpress() {
    var host = document.querySelector('[data-az-express]');
    if (!host) return;
    var my = ++exprSeq;
    fetch('/?sections=header', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (j) {
        if (my !== exprSeq || !j || !j.header) return;
        var doc = new DOMParser().parseFromString(j.header, 'text/html');
        var fresh = doc.querySelector('[data-az-express]');
        if (!fresh) return;
        if (fresh.innerHTML.replace(/\s+/g, '') !== host.innerHTML.replace(/\s+/g, '')) host.innerHTML = fresh.innerHTML;
        syncOr();
      })
      .catch(function () { /* Knoepfe bleiben wie sie sind */ });
  }
  function syncOr() {
    var host = document.querySelector('[data-az-express]');
    var tg = document.querySelector('.az-quick-toggle');
    if (!host || !tg) return;
    tg.hidden = !host.children.length;
  }

  /* ===== Schnellbezahlung: ein Klick auf den Knopf klappt die Auswahl nach oben auf ===== */
  function footerVisible() {
    var f = document.querySelector('.mini-cart-footer');
    return !!(f && f.offsetParent !== null);
  }
  function setSheet(open) {
    var s = document.getElementById('az-quick-sheet');
    var t = document.querySelector('.az-quick-toggle');
    if (!s) return;
    if (open && !footerVisible()) open = false;
    if (open) {
      var f = document.querySelector('.mini-cart-footer');
      s.style.bottom = f.offsetHeight + 'px';
      hideToast();
      srcExpress();
      setTimeout(syncPrices, 200);
    }
    s.classList.toggle('is-open', open);
    if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function onQuickClick(ev) {
    var tg = ev.target && ev.target.closest ? ev.target.closest('.az-quick-toggle') : null;
    if (tg) { var s = document.getElementById('az-quick-sheet'); setSheet(!(s && s.classList.contains('is-open'))); return; }
    if (ev.target && ev.target.closest && ev.target.closest('.az-sheet__close')) { setSheet(false); return; }
    var s2 = document.getElementById('az-quick-sheet');
    if (s2 && s2.classList.contains('is-open') && ev.target && ev.target.closest &&
        !ev.target.closest('.az-sheet') && !ev.target.closest('.mini-cart-footer')) setSheet(false);
  }

  function init() {
    setEta();
    goldify();
    syncOr();
    updateFade();
    syncPrices();
    watchCartPage();
    document.addEventListener('click', onRemoveClick, true);
    document.addEventListener('click', onUndoClick, false);
    document.addEventListener('click', onAddClickCapture, true);
    document.addEventListener('click', onSrcClick, true);
    srcPageLoad();
    document.addEventListener('click', onQuickClick, false);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setSheet(false); });
    var sc = document.querySelector('.az-cart-scroll');
    if (sc) sc.addEventListener('scroll', updateFade, { passive: true });
    window.addEventListener('resize', updateFade);
    if (window.MutationObserver) {
      var t = null;
      var obs = new MutationObserver(function () {
        goldify();
        if (lastCartData) applyPrices(lastCartData);
        clearTimeout(t);
        t = setTimeout(function () { setEta(); updateFade(); syncPrices(); if (!footerVisible()) setSheet(false); }, 30);
      });
      var root = document.querySelector('.mini-cart-content');
      if (root) obs.observe(root, { childList: true, subtree: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-toggle-cart')) { setSheet(false); setEta(); setTimeout(updateFade, 50); refreshExpressSoon(); setTimeout(syncPrices, 300); }
      if (e.target && e.target.closest && e.target.closest('.overlaycart, .mini-cart-header .close')) setSheet(false);
    });
    hookAjax();
    if (!window.__azV3Ajax) window.addEventListener('load', hookAjax);
    setInterval(setEta, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
